const asyncQuerySelectorAll = (selector, root = document, threshold = 5000) => {
    return new Promise((resolve, reject) => {
        try {
        const intervalTime = 100;
        let time = 0;
        const interval = setInterval(() => {
            if (time >= threshold) {
            clearInterval(interval);
            resolve([]);
            }

            const elements = [...root.querySelectorAll(selector)];

            if (elements.length) {
            clearInterval(interval);
            resolve(elements);
            }

            time += intervalTime;
        }, intervalTime);
        } catch (e) { 
        console.error(e) 
        }
    })
}
(
async function addClassToButtons() {

    const mobileApplyButtons = await asyncQuerySelectorAll('.boost-pfs-filter-show-result');
    if (mobileApplyButtons.length) {
        mobileApplyButtons.forEach(function(button) {
            button.classList.add('button', 'button--primary');
            button.classList.remove('.boost-pfs-filter-show-result');
        });
    }

    const applyButtons = await asyncQuerySelectorAll('.boost-pfs-filter-apply-button');
    if (applyButtons.length) {
        applyButtons.forEach(function(button) {
            button.classList.add('button', 'button--primary');
            button.classList.remove('boost-pfs-filter-button', 'boost-pfs-filter-apply-button');
        });
    }
}
)();